import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [

    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    // },
    // {
    //     cameraLocationId: 'W01Z01',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: `Look Under Seat #1`,
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N',
    // },
    {
        cameraLocationId: 'GroundFloorCamLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Ground Floor`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['NANWENG01', 'NANCIDG01', 'NANHDSG01', 'NANHDSG02', 'NANHGSG01', 'NANHGSG01B', 'NANCLOG01', 'VENCORG01', 'VENRESG01', 'NANDEPG01'],
    },
    {
        cameraLocationId: 'NANWENG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Welcome to Venice`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANCIDG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Information Desk`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANHDSG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Saint Mark`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANHDSG02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Annunciation`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANHGSG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Madonna & Child 1-6`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANHGSG01B',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Madonna & Child 7-12`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANCLOG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Crucifixion`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'VENCORG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Coronation of the Virgin`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'VENRESG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Resurrection`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },

    {
        cameraLocationId: 'NANDEPG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Departure Lounge`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'FirstFloorCamLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `First Floor`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['NANPORG01', 'VENGLAG01', 'VENTEXG01', 'NANTHEG01'],
    },
    {
        cameraLocationId: 'NANPORG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Carved Personal Altars`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'VENGLAG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Glass`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'VENTEXG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Textiles`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'NANTHEG01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Theatre`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'DownStairsLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Down Stairs`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        hideFromModal: 'Y',
    },
    {
        cameraLocationId: 'UpStairsLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Up Stairs`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        hideFromModal: 'Y',
    }

];

export {CameraLocationsDB, FLOOR_NUMBER};
